import { EnumField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';

interface EmployeeCompetencyLevelFieldProps extends FieldProps {
  value?: Nullable<string>;
  source?: Nullable<string>;
  label?: Nullable<string>;
}

const EmployeeCompetencyLevelField = ({
  value: inputValue = null,
  source = null,
  label = null,
}: EmployeeCompetencyLevelFieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });
  const value = inputValue || (getValue && getValue());

  return <EnumField label={label} value={value} options={EMPLOYEE_COMPETENCY_LEVEL} />;
};

export default EmployeeCompetencyLevelField;
